import {Amplify} from '@aws-amplify/core'

export {
  Analytics,
  AnalyticsProvider,
  AWSPinpointProvider,
  AWSKinesisProvider,
  AWSKinesisFirehoseProvider,
  AmazonPersonalizeProvider,
} from '@aws-amplify/analytics'
export {Auth} from '@aws-amplify/auth'
export {CognitoHostedUIIdentityProvider} from '@aws-amplify/auth/lib-esm/types'
export {Storage, StorageClass} from '@aws-amplify/storage'
export {API, APIClass, graphqlOperation} from '@aws-amplify/api'
export {AuthModeStrategyType, Predicates, SortDirection, syncExpression,} from '@aws-amplify/datastore'
export {default as Cache} from '@aws-amplify/cache'
export {
  ConsoleLogger as Logger, Hub, JS, ClientDevice, Signer, I18n, ServiceWorker, AWSCloudWatchProvider,
} from '@aws-amplify/core'
export {Amplify}
/**
 * @deprecated use named import
 */
export default Amplify
